import { render, staticRenderFns } from "./WeightSku.vue?vue&type=template&id=32a22e68&scoped=true"
import script from "./WeightSku.vue?vue&type=script&lang=js"
export * from "./WeightSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a22e68",
  null
  
)

export default component.exports